import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import InstallerForm from './components/installerForm';
import {
  createInstaller,
  navigate,
  clearValidationErrors,
  requestWorkroomList,
} from 'actionCreators';
import {
  getInstallerErrors,
  getWorkroomList,
  getPayRateUploadsError,
  getPayRateUploadsLoading,
  getRole,
} from '../../../../reducers';
import connectUI from 'redux-ui';
import { confirm } from '../../../../utils';
import getAllowedInstallerTabs from './installerAllowedTabs';

class InstallerNew extends Component {
  constructor(props) {
    super(props);
    this.handleSave = this.handleSave.bind(this);
    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleCancel = () => { this.props.navigate('/installers'); };
  }

  componentDidMount() {
    this.resetTab();
    this.props.requestWorkroomList();
  }

  componentWillUnmount() {
    this.props.clearValidationErrors('INSTALLER');
  }

  resetTab() {
    this.props.updateUI('activeTab', 0);
  }

  afterCompRenders = () => {
    setTimeout(() => {
      const tabs = getAllowedInstallerTabs(
        this.props.role,
        (this.props.user && this.props.user.manage_vendor_workrooms) || {},
      );
      const payRatesIdx = tabs.findIndex(tab => tab.label === 'Pay Rates');
      this.props.updateUI('activeTab', payRatesIdx >= 0 ? payRatesIdx : 0);
    }, 1000);
  }

  handleSave(installer) {
    return this.props.createInstaller(installer)
      .then(([, json]) => (
        confirm('Would you like to upload a pay rate document now?',
          { title: 'Installer Pay Rates', okLabel: 'Yes', cancelLabel: 'No' })
          .then(() => {
            if (json && {}.hasOwnProperty.call(json, 'id')) {
              this.afterCompRenders();
              this.props.navigate(`/installers/${json.id}/edit`);
            }
            return true;
          }).catch(() => {
            if (installer.user_attributes.name) {
              this.props.updateUI('successMessage', `"${installer.user_attributes.name}" was successfully added as an installer.`);
              this.props.navigate('/installers');
            }
            return true;
          })
      ));
  }

  handleTabChange(tabIndex) {
    this.props.updateUI('activeTab', tabIndex);
  }

  render() {
    const { errors, allWorkrooms, ui, uploadError, fileLoading, role, user } = this.props;

    return (
      <InstallerForm
        errors={errors}
        allWorkrooms={allWorkrooms}
        onSave={this.handleSave}
        onCancel={this.handleCancel}
        activeTab={ui.activeTab}
        onTabChange={this.handleTabChange}
        uploadError={uploadError}
        fileLoading={fileLoading}
        role={role}
        user={user}
        installerFormType={'New'}
      />
    );
  }
}

InstallerNew.propTypes = {
  navigate: PropTypes.func,
  clearValidationErrors: PropTypes.func,
  updateUI: PropTypes.func,
  requestWorkroomList: PropTypes.func,
  createInstaller: PropTypes.func,
  errors: PropTypes.object,
  allWorkrooms: PropTypes.array,
  ui: PropTypes.object,
  uploadError: PropTypes.string,
  fileLoading: PropTypes.bool,
  role: PropTypes.string.isRequired,
  user: PropTypes.object,
};

const mapStateToProps = state => (
  {
    errors: getInstallerErrors(state) || {},
    allWorkrooms: getWorkroomList(state),
    uploadError: getPayRateUploadsError(state),
    fileLoading: getPayRateUploadsLoading(state),
    role: getRole(state),
    user: state.user,
  }
);

export default connectUI()(connect(mapStateToProps, {
  navigate,
  createInstaller,
  clearValidationErrors,
  requestWorkroomList,
},
)(InstallerNew));



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/installers/installerNew.jsx